// hooks/useSyncFiltersWithURL.ts
import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { setFilter } from '../store/reducers/appSlice';

export const useSyncFiltersWithURL = () => {
    const dispatch = useAppDispatch();
    const filter = useAppSelector(store => store.AppSlice.filter);
    const isInitialLoad = useRef(true);
    const isApplyingUrlFilters = useRef(false);

    // Обновление URL при изменении фильтров
    useEffect(() => {
        if (isInitialLoad.current) {
            isInitialLoad.current = false;
            return;
        }

        if (isApplyingUrlFilters.current) {
            isApplyingUrlFilters.current = false;
            return;
        }

        const params = new URLSearchParams();

        Object.entries(filter).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '') return;

            if (Array.isArray(value)) {
                if (value.length > 0) {
                    params.set(key, value.join(','));
                }
            } else {
                params.set(key, value.toString());
            }
        });

        const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;
        window.history.replaceState(null, '', newUrl);
    }, [filter]);

    // Восстановление фильтров из URL при загрузке
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const urlFilters: any = {};

        if (params.toString() === '') return;

        params.forEach((value, key) => {
            if (key === 'activity') {
                // Для activity всегда должен быть массив
                urlFilters[key] = value.split(',').map(item => {
                    const num = Number(item);
                    return isNaN(num) ? item : num;
                });
            } else if (value.includes(',')) {
                urlFilters[key] = value.split(',').map(item => {
                    const num = Number(item);
                    return isNaN(num) ? item : num;
                });
            } else {
                const num = Number(value);
                urlFilters[key] = isNaN(num) ? value : num;
            }
        });

        if (Object.keys(urlFilters).length > 0) {
            isApplyingUrlFilters.current = true;
            dispatch(setFilter(urlFilters));
        }
    }, [dispatch]);

    return null;
};